import React from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import "../styles/SectionWrap.scss"

const SectionWrap = props => {
  return (
    <section
      className={classnames(
        { sectionWrap: true, maxWidth: props.maxWidth },
        props.className
      )}
    >
      {props.id !== null && <span id={props.id} className="anchorTarget" />}
      {props.title !== null && (
        <h2
          className={classnames({
            sectionIdentifier: true,
            hidden: !props.showTitle,
          })}
        >
          {props.title}
        </h2>
      )}
      {props.children}
    </section>
  )
}

SectionWrap.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  className: PropTypes.string,
  showTitle: PropTypes.bool,
  maxWidth: PropTypes.bool,
  id: PropTypes.string,
}

SectionWrap.defaultProps = {
  children: null,
  title: null,
  className: "",
  showTitle: true,
  maxWidth: true,
  id: null,
}

export default SectionWrap
